module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-16.39ef8c7d.png";